import { ZapDialog } from '@/components/ZapDialog';
import { useWallet } from '@/hooks/useWallet';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { useAuthor } from '@/hooks/useAuthor';
import { Zap } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { Event } from 'nostr-tools';

interface ZapButtonProps {
  eventId?: string;
  recipientPubkey?: string;
  event?: Event;
  size?: 'default' | 'sm' | 'lg' | 'icon';
  variant?: 'default' | 'outline' | 'ghost';
  className?: string;
}

export function ZapButton({
  eventId,
  recipientPubkey,
  event,
  size = 'icon',
  variant = 'outline',
  className = ''
}: ZapButtonProps) {
  const { user } = useCurrentUser();
  const { data: author } = useAuthor(recipientPubkey || event?.pubkey);
  const { webln, activeNWC } = useWallet();

  // Determine the recipient's pubkey
  const targetPubkey = recipientPubkey || event?.pubkey;

  // Don't show zap button if user is trying to zap their own content
  if (user && targetPubkey === user.pubkey) {
    return null;
  }

  return (
    <ZapDialog
      eventId={eventId}
      recipientPubkey={recipientPubkey}
      event={event}
    >
      <Button
        size={size}
        variant={variant}
        className={`rounded-full border-0 aspect-square p-0 flex items-center justify-center ${size === 'icon' ? 'h-10 w-10' : ''} ${className}`}
      >
        <Zap className={size === 'lg' ? 'h-5 w-5' : 'h-4 w-4'} />
      </Button>
    </ZapDialog>
  );
}